import React from "react";
import "../Assets/styles/Loader.css"

const Loader = () => {
  return (
    <div className="spinner-loader">
      <div className="flipping">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
